<template>
 <div class="container">

<h1><font-awesome-icon icon="home" /> Home  - <a href="#">Dorms </a>

<div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>


  




</div>


</h1>

 

<div class="row">


 <div class="col-md-12" id="tabs">
<div class="tabs">
        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Booking</a>
        <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">YourBooking</a>
    
    </div>

    <div class="content">
        <div v-if="activetab === 1" class="tabcontent">
         <Booking v-bind:period="period" v-bind:Rooms="Rooms"  v-bind:Gender="currenUser.GenderName" />
        </div>
        <div v-if="activetab === 2" class="tabcontent">
       <YourBooking />
        </div>
      
    </div>




  </div>








</div>




</div>

</template>

<script>
// import Tap5 from "../../components/Dorms/Tap5.vue";
import Booking from "../../components/Dorms/Booking.vue";
import YourBooking from "../../components/Dorms/YourBooking.vue";
import DormsServices from '../../services/Dorms/Dorms.service'



export default {
   components: {
   Booking,YourBooking,
//   
  },
  data () {
    return {
           el: '#tabs',
    activetab: 1,
      info: '',
    period:[],
    Rooms:[],
    GenderID: 0 
    }
  },
   computed:{
          currenUser(){
            return  this.$store.state.auth.user
          },
        
        },

  mounted(){
     DormsServices.GetAll_DormsRoomResrvationPeriod().then(response=>{
       this.period = response.data
       console.log(this.period)
       })
      
       if(this.currenUser.GenderName == "Male"){
         this.GenderID = 1 
       }else{
         this.GenderID = 2
       }
     DormsServices.GetAllDormsRoomCategories(this.GenderID).then(response=>{
       this.Rooms = response.data
       
       })
  }
  



}


</script>

<style scoped>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#ff8600;
}

.panal{
  background:#eee;
  border-radius:10px;
color:#333;
    border: 1px solid #d4d4d4;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}

/* Style the tabs */
.tabs {
    overflow: hidden;
  margin-left: 20px;
    margin-bottom: -2px; 
}

.tabs ul {
    list-style-type: none;
    margin-left: 20px;
}

.tabs a{
    float: left;
    cursor: pointer;
    padding: 12px 24px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #285475;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
     color: #fff;
}
.tabs a:last-child { 
    border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
    background-color: #aaa;
    color: #fff;
}

/* Styling for active tab */
.tabs a.active {
   background-color: #fff;
    color: #285475;
    border-bottom: 2px solid #fff;
    cursor: default;
}

/* Style the tab content */
.tabcontent {
    padding: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  background: #fff;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}


</style>